import { ssv2303ConfiAutoFncraResource } from '@/shared/api.resource';

import {
  FETCH_SSV2303_CONFI_AUTO_FNCRA_BY_ID,
  FETCH_PAGINATED_SSV2303_CONFI_AUTO_FNCRAS,
  UPDATE_SSV2303_CONFI_AUTO_FNCRA,
  CREATE_SSV2303_CONFI_AUTO_FNCRA,
  DELETE_SSV2303_CONFI_AUTO_FNCRA,
  RESET_SSV2303_CONFI_AUTO_FNCRA_FILTERS,
  RESET_SSV2303_CONFI_AUTO_FNCRA,
  RESET_SSV2303_CONFI_AUTO_FNCRAS_LIST,
} from './actions.type';

import {
  SET_SSV2303_CONFI_AUTO_FNCRA,
  SET_PAGINATED_SSV2303_CONFI_AUTO_FNCRAS,
  RESET_STATE_SSV2303_CONFI_AUTO_FNCRA_FILTERS,
  RESET_STATE_SSV2303_CONFI_AUTO_FNCRA,
  RESET_STATE_SSV2303_CONFI_AUTO_FNCRA_LIST,
} from './mutations.type';

const initialState = {
  ssv2303ConfiAutoFncraFilters: {},
  ssv2303ConfiAutoFncra: {},
  paginatedSsv2303ConfiAutoFncras: {
    content: [],
    totalElements: 0,
    size: 0
  }
};

export const state = JSON.parse(JSON.stringify(initialState));

export const actions = {
  async [FETCH_SSV2303_CONFI_AUTO_FNCRA_BY_ID](context, id) {
    const { data } = await ssv2303ConfiAutoFncraResource.get({ id: id });
    context.commit(SET_SSV2303_CONFI_AUTO_FNCRA, data);
    return data;
  },
  async [FETCH_PAGINATED_SSV2303_CONFI_AUTO_FNCRAS](context, params) {
    const { data } = await ssv2303ConfiAutoFncraResource.query(params);
    context.commit(SET_PAGINATED_SSV2303_CONFI_AUTO_FNCRAS, data);
    return data;
  },
  async [CREATE_SSV2303_CONFI_AUTO_FNCRA](context) {
    const { data } = await ssv2303ConfiAutoFncraResource.save(state.ssv2303ConfiAutoFncra);
    context.commit(SET_SSV2303_CONFI_AUTO_FNCRA, data);
    return data;
  },
  async [UPDATE_SSV2303_CONFI_AUTO_FNCRA](context, id) {
    const { data } = await ssv2303ConfiAutoFncraResource.update({ id: id }, state.ssv2303ConfiAutoFncra);
    context.commit(SET_SSV2303_CONFI_AUTO_FNCRA, data);
    return data;
  },
  [DELETE_SSV2303_CONFI_AUTO_FNCRA](context, id) {
    return ssv2303ConfiAutoFncraResource.delete({ id: id });
  },
  [RESET_SSV2303_CONFI_AUTO_FNCRA_FILTERS]({ commit }) {
    commit(RESET_STATE_SSV2303_CONFI_AUTO_FNCRA_FILTERS);
  },
  [RESET_SSV2303_CONFI_AUTO_FNCRA]({ commit }) {
    commit(RESET_STATE_SSV2303_CONFI_AUTO_FNCRA);
  },
  [RESET_SSV2303_CONFI_AUTO_FNCRAS_LIST]({ commit }) {
    commit(RESET_STATE_SSV2303_CONFI_AUTO_FNCRA_LIST);
  }
};

export const mutations = {
  [SET_SSV2303_CONFI_AUTO_FNCRA](state, ssv2303ConfiAutoFncra) {
    state.ssv2303ConfiAutoFncra = ssv2303ConfiAutoFncra;
  },
  [SET_PAGINATED_SSV2303_CONFI_AUTO_FNCRAS](state, paginatedSsv2303ConfiAutoFncras) {
    state.paginatedSsv2303ConfiAutoFncras = paginatedSsv2303ConfiAutoFncras;
  },
  [RESET_STATE_SSV2303_CONFI_AUTO_FNCRA](state) {
    state.ssv2303ConfiAutoFncra = JSON.parse(JSON.stringify(initialState.ssv2303ConfiAutoFncra));
  },
  [RESET_STATE_SSV2303_CONFI_AUTO_FNCRA_FILTERS](state) {
    state.ssv2303ConfiAutoFncraFilters = JSON.parse(JSON.stringify(initialState.ssv2303ConfiAutoFncraFilters));
  },
  [RESET_STATE_SSV2303_CONFI_AUTO_FNCRA_LIST](state) {
    state.paginatedssv2303ConfiAutoFncras = JSON.parse(JSON.stringify(initialState.paginatedSsv2303ConfiAutoFncras));
  }
};

export const getters = {
  ssv2303ConfiAutoFncra(state) {
    return state.ssv2303ConfiAutoFncra;
  },
  ssv2303ConfiAutoFncraFilters(state) {
    return state.ssv2303ConfiAutoFncraFilters;
  },
  paginatedSsv2303ConfiAutoFncras(state) {
    return state.paginatedSsv2303ConfiAutoFncras;
  }
};

export default {
  state,
  actions,
  mutations,
  getters
}